import * as yup from 'yup';

import { VerificationRequestCreateFormFields } from 'src/constants/verificationRequest';

const stringValidationSchema = yup.string().nullable();
const requiredStringValidationSchema = stringValidationSchema.required('Required');

export const verificationRequestReviewInformationFormValidationSchema = yup.object({
  [VerificationRequestCreateFormFields.permissiblePurposeId]: requiredStringValidationSchema,
  [VerificationRequestCreateFormFields.verificationReportType]: requiredStringValidationSchema,
  [VerificationRequestCreateFormFields.paymentMethod]: yup
    .string()
    .nullable()
    .when('isCommercialVerifier', {
      is: true,
      then: schema => schema.required('Required'),
    }),
});
